import { render, staticRenderFns } from "./StockPurchaseOrderListReceivingPage.vue?vue&type=template&id=bf9a795e&"
import script from "./StockPurchaseOrderListReceivingPage.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderListReceivingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports